import { DangerButton } from '@shared/components/buttons';
import { useLogout } from '../hooks/use-logout';

const LogoutButton = () => {
  const logout = useLogout();

  return <DangerButton onClick={logout}>Log Out</DangerButton>;
};

export default LogoutButton;
